<template>
  <v-card outlined>
    <v-card-title class="text-subtitle-1">
      Kontaktpersonen
      <v-spacer></v-spacer>
      <v-btn 
        small 
        color="primary" 
        @click="$emit('add')"
      >
        <v-icon left small>mdi-account-plus</v-icon>
        Neuer Kontakt
      </v-btn>
    </v-card-title>

    <v-card-text>
      <div 
        v-if="contactPersons.length > 0" 
        :style="{ 
          'max-height': contactPersons.length > 2 ? '200px' : 'auto', 
          'overflow-y': contactPersons.length > 2 ? 'auto' : 'visible' 
        }"
        class="contact-list-container"
      >
        <v-list dense>
          <v-list-item
            v-for="contact in contactPersons"
            :key="contact.id"
            @click="$emit('edit', contact)"
            class="contact-item"
          >
            <v-list-item-content>
              <v-list-item-title>{{ contact.name }}</v-list-item-title>
              
              <v-list-item-subtitle v-if="contact.position">
                {{ contact.position }}
              </v-list-item-subtitle>
              
              <v-list-item-subtitle v-if="contact.email">
                <a 
                  :href="`mailto:${contact.email}`" 
                  class="email-link"
                  @click.stop
                >
                  {{ contact.email }}
                </a>
              </v-list-item-subtitle>
              
              <v-list-item-subtitle v-if="contact.phone">
                <a 
                  :href="`tel:${formatPhoneForLink(contact.phone)}`" 
                  class="phone-link"
                  @click.stop
                >
                  {{ contact.phone }}
                </a>
              </v-list-item-subtitle>

              <div v-if="!contact.email && !contact.phone" class="text-caption text--disabled mt-1">
                No contact information
              </div>
            </v-list-item-content>
            
            <v-list-item-action>
              <div class="action-buttons">
                <!-- Email button above phone button -->
                <v-btn 
                  v-if="contact.email" 
                  icon 
                  small
                  @click.stop="$emit('email', { contact })"
                  title="Send Email"
                  class="email-btn"
                >
                  <v-icon small>mdi-email</v-icon>
                </v-btn>
                
                <v-btn 
                  v-if="contact.phone" 
                  icon 
                  small
                  :href="`tel:${formatPhoneForLink(contact.phone)}`"
                  @click.stop
                  title="Call"
                  class="phone-btn"
                >
                  <v-icon small>mdi-phone</v-icon>
                </v-btn>
              </div>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </div>

      <div v-else class="text-center text--disabled py-3">
        Keine Kontaktpersonen hinzugefügt
      </div>

    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'ContactPersonsList',

  props: {
    contactPersons: {
      type: Array,
      default: () => []
    }
  },

  methods: {
    formatPhoneForLink(phone) {
      if (!phone) return ''
      return phone.replace(/[^\d+]/g, '')
    }
  }
}
</script>

<style scoped>
.contact-item {
  cursor: pointer;
  transition: background-color 0.2s;
  border-bottom: 1px solid #f0f0f0;
}

.contact-item:last-child {
  border-bottom: none;
}

.contact-item:hover {
  background-color: #f5f5f5;
}

.email-link,
.phone-link {
  text-decoration: none;
  color: #1976d2;
}

.email-link:hover,
.phone-link:hover {
  text-decoration: underline;
}

.action-buttons {
  display: flex;
  flex-direction: column; 
  gap: 4px;
  min-width: 40px; 
}

.email-btn {
  order: 1;
}

.phone-btn {
  order: 2;
}

.contact-list-container {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 0 4px;
}

.contact-list-container::-webkit-scrollbar {
  width: 6px;
}

.contact-list-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.contact-list-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.contact-list-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.v-list-item__content {
  padding-right: 8px;
}

.v-list-item__action {
  margin-left: 8px;
}
</style>